<ion-list [class.ghost]="ghostMode">
    <infra-charge [infraCharge]="chargeRecord?.infraChargeDto" [ghostMode]="ghostMode"></infra-charge>

    <ion-card>
        <ion-label class="ion-text-center">
            <div class="passContainer ghost-container">
                <p class="passContainer-title large-ghost-size">
                    <span class="ghost-hidden">{{'chargeRecord.media' | translate}}</span>
                </p>
                <p class="passContainer-number large-ghost-size">{{chargeRecord | chargeRecordMediaDisplayName}}</p>
            </div>
        </ion-label>
        <ion-card-title class="timeTitle large-ghost-size">
            <span class="ghost-hidden">
                {{'chargeRecord.chargingUntil' | translate}}
            </span>
        </ion-card-title>
        <ion-card-content class="timeContainer">
            <ion-grid class="ion-text-center">
                <ion-row>
                    <ion-col class="timer ghost-height">
                        <h6 class="timer-title ghost-hidden" [ngPlural]="chargeRecordDetailsDuration.hours">
                            <ng-template ngPluralCase="=1">{{'duration.hour' | translate}}</ng-template>
                            <ng-template ngPluralCase="other">{{'duration.hours' | translate}}</ng-template>
                        </h6>
                        <div class="timer-time ghost-hidden">
                            <h4>{{chargeRecordDetailsDuration.hours | number: '2.0-0'}}</h4>
                        </div>
                    </ion-col>

                    <ion-col size="1" class="timer-separatorPoint">:</ion-col>

                    <ion-col class="timer ghost-height">
                        <h6 class="timer-title ghost-hidden" [ngPlural]="chargeRecordDetailsDuration.minutes">
                            <ng-template ngPluralCase="=1">{{'duration.minute' | translate}}</ng-template>
                            <ng-template ngPluralCase="other">{{'duration.minutes' | translate}}</ng-template>
                        </h6>
                        <div class="timer-time ghost-hidden">
                            <h4>{{chargeRecordDetailsDuration.minutes | number: '2.0-0'}}</h4>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="chargeRecordPower">
                    <ion-col class="pricing ghost-height">
                        <h6 class="pricing-title ghost-hidden">{{'chargeRecord.powerQuantity' | translate}}</h6>
                        <div class="pricing-price ghost-hidden">
                            <h4>{{chargeRecordPower.powerQuantity | energy}}</h4>
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row *ngIf="consumptionPrice">
                    <ion-col class="pricing ghost-height">
                        <h6 class="pricing-title ghost-hidden">{{'chargeRecord.estimatePrice' | translate}}</h6>
                        <div class="pricing-price ghost-hidden">
                            <h4>{{consumptionPrice.priceWithVAT | currency:undefined: consumptionPrice.currencyUnit}}</h4>
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>
            <ion-button color="secondary"
                        [hidden]="chargeRecord?.status !== ChargeRecordStatus.CHARGING || !chargeRecord.remoteStop"
                        [disabled]="remoteRequest"
                        (click)="presentRemoteStop()" expand="block">
                <ng-container *ngIf="!remoteRequest else spinner">{{'chargeRecord.stop' | translate}}</ng-container>
            </ion-button>
        </ion-card-content>
    </ion-card>

</ion-list>
<remote [action]="Action.STOP" [request]="remoteRequest" (remoteResponse)="handleRemoteStopResponse($event)"></remote>
<ng-template #spinner>
    <ion-spinner></ion-spinner>
</ng-template>
